import * as ActionTypes from 'actions';

const initialState = {
  message: '',
  messageType: 'notice',
  visible: false,
};

export default function(state = initialState, action = {}) {
  const { type, message, messageType } = action;

  switch (type) {
  case ActionTypes.REMOVE_FLASH_MESSAGE:
    if (typeof message !== 'string' || state.message === message) {
      return Object.assign({}, state, initialState);
    }
    return state;

  case ActionTypes.FLASH_MESSAGE:
    return Object.assign({}, state, {
      message,
      messageType,
      visible: true,
    });

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/flashMessage.js